import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AddIndustryProductDiscount } from "src/app/ui/models/domains/pbm/industry/add-industry-product-discount.model";
import { IndustryCompany } from "src/app/ui/models/domains/pbm/industry/industry-company.model";
import { IndustryDiscountSearchParameters } from "src/app/ui/models/domains/pbm/industry/industry-discount-search-parameters.model";
import { IndustryDiscount } from "src/app/ui/models/domains/pbm/industry/industry-discount.model";
import {
  IndustryProductDiscountKey,
  IndustryProductDiscounts,
  IndustryProductEan,
} from "src/app/ui/models/domains/pbm/industry/industry-product-discounts.model";
import { LoadingService } from "src/app/ui/services/loading.service";
import { IndustryDiscountsService } from "src/app/ui/services/pbm/industry-discounts.service";
import { Toast } from "../../../toast/toast";
import { ConfirmDialog } from "../../shared/dialogs/confirm-dialog/confirm-dialog.component";
import { AddLpmProductDialogComponent } from "./add-lpm-product-dialog/add-lpm-product-dialog.component";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";

@Component({
  selector: "edit-lpm",
  templateUrl: "./edit-lpm.component.html",
  styleUrls: ["./edit-lpm.component.scss"],
})
export class EditLpmComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ean: string = "";
  displayedColumns: string[] = ["ean", "userDiscount", "directDiscount", "indirectDiscount", "deleteProduct"];
  industryDiscount: IndustryDiscount;
  dataSource = new MatTableDataSource<IndustryProductDiscounts>();
  confirmDialogRef: MatDialogRef<ConfirmDialog>;
  addLpmProductDialogRef: MatDialogRef<AddLpmProductDialogComponent>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private industryDiscountsService: IndustryDiscountsService,
    private loadingService: LoadingService,
    private toast: Toast,
    private dialog: MatDialog,
  ) {}

  async ngOnInit() {}

  async ngAfterViewInit() {
    const industryDiscountKey = this.activatedRoute.snapshot.params.industryDiscountKey;
    await this.getIndustryDiscount(industryDiscountKey, "");
    this.dataSource.paginator = this.paginator;
  }

  public hasIndustryProductDiscounts(): boolean {
    return !!this.industryDiscount && this.industryDiscount.getIndustryProductDiscounts().length > 0;
  }

  public getIndustryProductDiscounts(): Array<IndustryProductDiscounts> {
    return this.industryDiscount.getIndustryProductDiscounts();
  }

  public getIndustryCompany(): IndustryCompany {
    return this.industryDiscount.getCompany();
  }

  public hasIndustryCompany(): boolean {
    return !!this.industryDiscount && !!this.industryDiscount.getCompany();
  }

  public async getIndustryDiscount(industryDiscountKey: string, filterText: string): Promise<void> {
    const loadignRef = this.loadingService.beginLoading();
    const industryDiscountSearchParameters = new IndustryDiscountSearchParameters();
    industryDiscountSearchParameters.setFilterText(filterText);
    industryDiscountSearchParameters.setStartIndex(1);
    industryDiscountSearchParameters.setTotalPerPages(30);

    try {
      this.industryDiscount = await this.industryDiscountsService.getIndustryProductDiscounts(industryDiscountKey, industryDiscountSearchParameters);
      if(this.industryDiscount.getIndustryProductDiscounts().length > 0){
        this.dataSource = new MatTableDataSource<IndustryProductDiscounts>(this.industryDiscount.getIndustryProductDiscounts());
      }else{
        this.toast.showWarningToast("Esta LPM ainda não possui produtos com descontos.");
      }
    } catch (ex) {
      this.toast.showWarningToast("Houve um problema ao carregar os descontos da indústria. Tente novamente mais tarde.");
    } finally {
      loadignRef.closeLoading();
    }
  }

  public async onChangeData($event: any, industryProductDiscountKey: IndustryProductDiscountKey): Promise<void> {
    const loadignRef = this.loadingService.beginLoading();

    const index = this.dataSource.filteredData.findIndex((item) => item.getIndustryProductDiscountKey() === industryProductDiscountKey);

    if (index != -1) {
      try {
        await this.industryDiscountsService.updateIndustryDiscountsProduct(this.dataSource.filteredData[index]);
      } catch {
        this.toast.showWarningToast("Houve um problema ao atualizar o desconto. Tente novamente.");
      } finally {
        loadignRef.closeLoading();
      }
    }
  }

  public async deleteProduct(industryProductDiscounts: IndustryProductDiscounts): Promise<void> {
    const loadignRef = this.loadingService.beginLoading();
    try {
      await this.industryDiscountsService.deleteProduct(industryProductDiscounts.getIndustryProductDiscountKey().getValue());

      const index = this.dataSource.filteredData.findIndex(
        (item) => item.getIndustryProductDiscountKey() === industryProductDiscounts.getIndustryProductDiscountKey(),
      );
      if (index != -1) {
        this.dataSource.filteredData.splice(index, 1);
        this.dataSource._updateChangeSubscription();
      }
    } catch {
      this.toast.showWarningToast("Houve um problema ao deletar os descontos, Tente novamente.");
    } finally {
      loadignRef.closeLoading();
    }
  }

  public onDeleteProduct(industryProductDiscounts: IndustryProductDiscounts): void {
    this.confirmDialogRef = this.dialog.open(ConfirmDialog, {
      disableClose: true,
      hasBackdrop: true,
      height: "200px",
      width: "600px",
      data: {
        title: "Remover descontos ",
        text: "Deseja remover os descontos do produto?",
      },
    });

    this.confirmDialogRef.componentInstance.confirmDialogEvent.subscribe(async () => {
      this.deleteProduct(industryProductDiscounts);
    });
  }

  public addLpmProduct(): void {
    const industryDiscountKey = this.activatedRoute.snapshot.params.industryDiscountKey;

    this.addLpmProductDialogRef = this.dialog.open(AddLpmProductDialogComponent, {
      disableClose: true,
      hasBackdrop: true,
      height: "330px",
      width: "440px",
      data: industryDiscountKey,
    });

    this.addLpmProductDialogRef.componentInstance.addInsdustryProductDialogEvent.subscribe(async (addIndustryProductDiscount: AddIndustryProductDiscount) => {
      const industryProductDiscounts = new IndustryProductDiscounts(
        new IndustryProductDiscountKey(addIndustryProductDiscount.getIndustryDiscountId()),
        new IndustryProductEan(addIndustryProductDiscount.getEan()),
        addIndustryProductDiscount.getUserDiscount(),
        addIndustryProductDiscount.getDirectDiscount(),
        addIndustryProductDiscount.getIndirectDiscount(),
      );

      this.dataSource.filteredData.push(industryProductDiscounts);
      this.dataSource._updateChangeSubscription();
    });
  }

  public async searchProductsByEan(): Promise<void> {
    const industryDiscountKey = this.activatedRoute.snapshot.params.industryDiscountKey;
    await this.getIndustryDiscount(industryDiscountKey, this.ean);

    this.dataSource = new MatTableDataSource<IndustryProductDiscounts>(this.industryDiscount.getIndustryProductDiscounts());
    this.dataSource.paginator = this.paginator;
  }
}
